import { DateSchema } from '@dissidium/contracts';

export const OPENING_DATE = Object.freeze({ day: 18, month: 'Sheaf', year: 641 } as const);
export const RETURN_DATE = Object.freeze({ day: 30, month: 'Press', year: 641 } as const);
export const FIRST_EMBER = Object.freeze({ day: 1, month: 'Ember', year: 641 } as const);
export const INTERVAL_DAYS = (30 - OPENING_DATE.day) + RETURN_DATE.day;
export function formatDate(date: unknown): string {
  const value = DateSchema.parse(date);
  return `${value.day} ${value.month} ${value.year} AC`;
}
/** The natural fold alone permits a Return. Threat state is not an input. */
export function returnTransition(settlement: 'folded' | 'settled'): 'next-run' | null {
  if (settlement !== 'folded' && settlement !== 'settled') throw new Error('Unknown chronology state');
  return settlement === 'folded' ? 'next-run' : null;
}
